<template>
  <div class="container network">
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="network__img-container">
          <img
            src="/images/ultra-fast-network.webp"
            alt="Mobile phone showing fast network connection"
            class="network__img"
            loading="lazy"
            width="300"
            height="192"
          />
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="network__text-container">
          <h2 class="network__h2 mb-4">Ultra Fast Network</h2>
          <div class="network__pills">
            <div class="network__pill">
              <div class="network__pill-inner">
                <img src="/images/fiveg-icon.webp" alt="5G icon" class="network__pill-icon network__pill-icon--wider" loading="lazy"  />
                <div class="network__text">Fast 5G as standard</div>
              </div>
            </div>
            <div class="network__pill">
              <div class="network__pill-inner">
                <img src="/images/unlimited-icon.webp" alt="Unlimited data icon" class="network__pill-icon" loading="lazy"  />
                <div class="network__text">Uncapped data</div>
              </div>
            </div>
          </div>
          <div class="network__text my-5">
            Our SIM plans run on the UK's most reliable mobile network with a growing fast 5G network, including free roaming usage in many destinations worldwide.
          </div>
          <div class="container-fluid">
            <ul class="row network__list">
              <li class="col-12 col-lg-6 mb-3">
                <h5 class="network__list-title">No contract</h5>
                <p class="network__list-tex">Just low cost pay as you go plans and you are free to cancel anytime</p>
              </li>
              <li class="col-12 col-lg-6 mb-3">
                <h5 class="network__list-title">Everyone accepted</h5>
                <p class="network__list-tex">No credit checks just flexible SIM plans for everyone. Including those with bad credit</p>
              </li>
              <li class="col-12 col-lg-6 mb-3">
                <h5 class="network__list-title">No price hikes</h5>
                <p class="network__list-tex">Your plan won't change even if the world does!</p>
              </li>
              <li class="col-12 col-lg-6">
                <h5 class="network__list-title">Roam freely</h5>
                <p class="network__list-tex">All plans can be used in 75 Worldwide Destinations</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
h2,
h5 {
  color: var(--peach);
}

h2 {
  font-size: 2em;
  @media only screen and (min-width: 992px) {
    font-size: 2.6em;
  }
}

h5 {
  font-size: 1.4em;
  @media only screen and (min-width: 992px) {
    font-size: 1.8em;
  }
}

.network {
  margin: 5em auto;
  padding: 0 2rem;
  display: flex;
  filter: drop-shadow(var(--box-shadow));

  &__img-container {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
  }
  &__img {
    width: 60%;
    max-width: 300px;
    height: auto;
    display: block;
    margin: 0 auto 2em;
    @media only screen and (min-width: 992px) {
      width: 100%;
      max-width: 450px;
      margin: 0;
      padding: 0;
    }
  }
  &__pills {
    display: flex;
    flex-direction: column;
    @media only screen and (min-width: 768px) {
      flex-direction: row;
    }
  }
  &__pill {
    width: 100%;
    @media only screen and (min-width: 768px) {
      width: 50%;
    }
  }
  &__pill-inner {
    padding: 1em 2em;
    margin: 0 0.5em;
    background: var(--black);
    border-radius: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: var(--peach);
    margin-bottom: 1em;
    @media only screen and (min-width: 768px) {
      margin-bottom: 0;
    }
  }
  &__pill-icon {
    height: 15px;
    width: auto;
    margin-right: 10px;
    &--wider {
      height: 25px;
    }
  }
  &__list {
    list-style-type: none;
    padding: 0;
  }
  &__text-container {
    text-align: center;
    color: var(--primary);

    @media only screen and (min-width: 992px) {
      text-align: left;
    }
  }

  &__text {
    color: var(--white);
  }
}
</style>
